
export { default as FmImage } from "./basic/FmImage"